export default "__VITE_ASSET__CPB6MRwE__"